export class GridHeaderService {
  static readonly HEADER_HEIGHT_DEFAULT = 40;
}
